import 'bootstrap/dist/js/bootstrap.js'
import 'bootstrap/js/dist/tooltip';
import { Tooltip } from 'bootstrap'

import { createApp } from 'vue'
import router from '@/router.js'
import store from '@/store.js'
import locales from '@/locales'
import App from '@/App.vue'
import Icon from "@/components/Icon.vue"
import formatters  from "@/mixins/formaters.js";

const app = createApp(App)
app.use(locales)
app.use(router)
app.use(store)
app.mixin(formatters)
app.mount('#app')
app.component('icon', Icon)


const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(el => new Tooltip(el))
